import './App.css';
import {Suspense, useEffect, useState} from "react";
import {AnimatePresence} from "framer-motion";
import {UserProvider} from "./Context/UserContext";
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import Login from "./pages/Login";
import {Shell} from "./components/shell";
import {loginEvent} from "./Context/events";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import NewClient from "./pages/NewClient";
import EditClient from "./pages/EditClient";
import "react-datepicker/dist/react-datepicker.css";
import Users from "./pages/Users";
import Partners from "./pages/Partners";
import PartnerDetail from "./pages/PartnerDetail";
import ClientRequests from "./pages/ClientRequests";
import CreateClientFromRequest from "./pages/CreateClientFromRequest";
import TenantMigrations from "./pages/TenantMigrations";
import WhatsAppDashboard from "./pages/WhatsAppDashboard";
import AiSpendDashboard from "./pages/AiSpendDashboard";
import {checkToken} from "./servicesV2/authService";
import MarketplaceSignup from "./pages/MarketplaceSignup";
import {ToastProvider} from "./components/ui";

const router = (isLogged) => createBrowserRouter([
  {
    path: "/",
    element: isLogged ? <Shell/> : <Navigate to="/login" />,
    children: [
      {
        path: "/",
        element: <Dashboard/>
      },{
        path: "/clients",
        element: <Clients/>
      },{
        path: "/new-client",
        element: <NewClient/>
      },{
        path: "/edit-client/:clientId",
        element: <EditClient/>
      }, {
        path: "/users",
        element: <Users/>
      },{
        path: "/partners",
        element: <Partners/>
      },{
        path: "/partners/:partnerId",
        element: <PartnerDetail/>
      },{
        path: "/client-requests",
        element: <ClientRequests/>
      },{
        path: "/client-requests/:requestId/create-client",
        element: <CreateClientFromRequest/>
      },{
        path: "/migrations",
        element: <TenantMigrations/>
      },{
        path: "/whatsapp",
        element: <WhatsAppDashboard/>
      },{
        path: "/ai-spend",
        element: <AiSpendDashboard/>
      }
    ]
  }
    ,{
    path: "/login",
    element: isLogged ? <Navigate to="/" /> : <Login/>,
  },
  {
    path: "/marketplace/signup",
    element: <MarketplaceSignup />,
  }
]);

function App() {

  const [isLogged, setIsLogged] = useState(null);

  useEffect(() => {
    checkToken()
      .then(() => setIsLogged(true))
      .catch(() => setIsLogged(false));
  }, []);

  useEffect(() => {
    const handleLoginEvent = (state) => {
      setIsLogged(state);
    };

    loginEvent.on('login', handleLoginEvent);

    return () => {
      loginEvent.removeListener('login', handleLoginEvent);
    };
  }, [loginEvent]);

  if(isLogged === null){
    return(
      <Suspense fallback="loading">
        <div className="min-h-[90vh] relative flex items-center justify-center">
          <div className='loading'>
            <div className='box'/>
          </div>
        </div>
      </Suspense>
    )
  }

  return (
    <Suspense fallback="loading">
      <AnimatePresence>
        <div >
          <UserProvider >
            <RouterProvider router={router(isLogged)} />
            <ToastProvider />
          </UserProvider>
        </div>
      </AnimatePresence>
    </Suspense>
  );
}

export default App;
